@if (resAsync | async) {
  <div fxLayout="row">
    <mat-radio-group
      aria-label="Select an option"
      name="exportMode"
      [(ngModel)]="selectedExportMode"
      class="export-mode-selection"
    >
      <mat-radio-button class="visible-area-mode" value="VisibleArea">{{
        res.get('CurrentMapSection')
      }}</mat-radio-button>
      <mat-radio-button value="MarkedArea">
        <span style="display: flex; align-items: center; gap: 8px">
          {{ res.get('SelectMapSection') }}
          <button
            mat-icon-button
            (click)="selectPolygon()"
            [disabled]="selectedExportMode === 'VisibleArea'"
            class="polygon-selection-btn"
            [ngClass]="{
              'polygon-button-disabled': selectedExportMode === 'VisibleArea',
            }"
          >
            <mat-icon [svgIcon]="res.svgName('Select-Polygon')"></mat-icon>
          </button>
          @if (selectedPolygon) {
            <p
              class="polygon-selection-text"
              [ngClass]="{
                'polygon-text-disabled': selectedExportMode === 'VisibleArea',
              }"
            >
              {{ res.get('PolygonSelectionText') }}
            </p>
          }
        </span>
      </mat-radio-button>
    </mat-radio-group>
  </div>
}
